import { fixUrlStr } from '@nextgis/utils';

import type { GetClassAdapterOptions } from '@nextgis/ngw-kit';
import type { Type } from '@nextgis/utils';
import type {
  MainLayerAdapter,
  Tileset3DAdapterOptions,
} from '@nextgis/webmap';

export async function createTileset3DAdapter({
  webMap,
  item,
  connector,
  layerOptions,
}: GetClassAdapterOptions): Promise<
  Type<MainLayerAdapter<any, any, Tileset3DAdapterOptions>> | undefined
> {
  const tilset3d = item.tileset_3d;
  if (tilset3d) {
    const jsonName = tilset3d.main_tileset;
    if (jsonName) {
      const useTerrainHeight = tilset3d.with_terrain_height;
      const heightOffset = tilset3d.z_offset;
      const url = fixUrlStr(
        `${connector.options.baseUrl}/api/resource/${item.resource.id}/file/${jsonName}`,
      );
      const Tileset3DAdapter = webMap.mapAdapter.layerAdapters
        .TILESET_3D as Type<
        MainLayerAdapter<any, any, Tileset3DAdapterOptions>
      >;
      if (Tileset3DAdapter) {
        let maximumScreenSpaceError =
          item.resmeta?.items && item.resmeta.items.maximumScreenSpaceError;
        const adapterOptions =
          (layerOptions && layerOptions.adapterOptions) || {};
        if (
          adapterOptions.nativeOptions &&
          adapterOptions.nativeOptions.maximumScreenSpaceError
        ) {
          maximumScreenSpaceError =
            adapterOptions.nativeOptions.maximumScreenSpaceError;
        }
        class NgwTileset3DAdapter extends Tileset3DAdapter {
          options = {
            url,
            useTerrainHeight:
              useTerrainHeight !== null ? useTerrainHeight : undefined,
            heightOffset: heightOffset !== null ? heightOffset : undefined,
            ...adapterOptions,
            nativeOptions: {
              maximumScreenSpaceError,
            },
          };
        }
        return NgwTileset3DAdapter;
      }
    }
  }
}
